var map = {
	"./1.png": "1755",
	"./10.png": "53b6",
	"./2.png": "78be",
	"./3.png": "fa0d",
	"./4.png": "b65f",
	"./5.png": "2844",
	"./6.png": "71eb",
	"./7.png": "21b4",
	"./8.png": "643e",
	"./9.png": "fe45"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "081c";